/**
* Full Page Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Full Page Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'full-page-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.full-page-left-right .images-area' ).each( function( key, val ) {
        if ( window.innerWidth > 1024 && window.hasMotion ) {
          const componentHeight = $( this ).closest( 'section' ).outerHeight();
          const docStyle = getComputedStyle( document.documentElement );
          const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
          const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
          const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
          const image = $( this ).find( 'img' )[0];

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              pin: true,
              start: 'top ' + topOffset,
              end: '+=' + ( componentHeight - $( this ).find( '.image-wrapper' ).height() ),
              scrub: 0,
              // markers: true,
            },
          } );

          $( this ).find( '.image-wrapper:not(:last-child)' ).each( function( imageKey, image ) {
            const height = $( image ).outerHeight();
            const docStyle = getComputedStyle( document.documentElement );
            const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
            const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
            const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );

            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: ( height * imageKey ) + ' ' + topOffset,
                end: '+=' + height,
                scrub: 0,
                // markers: true,
              },
            } );
            tl.to( image, {y: '100%', ease: 'linear'}, 0 );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'full-page-left-right', COMPONENT );
} )( app );
